import { Check } from "lucide-react";

const STAPPEN = ["Aanvraag", "Gegevens", "Betaling"];

export function OfferteStappen({ active = 1 }) {
  return (
    <div data-testid="offerte-stappen" className="flex items-center gap-2 mb-6">
      {STAPPEN.map((label, i) => {
        const num = i + 1;
        const done = num < active;
        const current = num === active;
        return (
          <div key={label} className="flex items-center gap-2">
            <div className={`flex items-center gap-2 px-3 py-1.5 rounded-sm border ${
              current ? "border-orange-500 bg-orange-50 text-orange-700"
              : done ? "border-green-500 bg-green-50 text-green-700"
              : "border-slate-200 bg-white text-slate-400"}`}>
              <span className={`flex items-center justify-center w-5 h-5 rounded-full text-xs font-bold ${
                current ? "bg-orange-500 text-white"
                : done ? "bg-green-600 text-white"
                : "bg-slate-200 text-slate-500"}`}>
                {done ? <Check className="w-3 h-3" /> : num}
              </span>
              <span className="text-sm font-semibold">{label}</span>
            </div>
            {num < STAPPEN.length && <span className="text-slate-300">→</span>}
          </div>
        );
      })}
    </div>
  );
}
